import { render, staticRenderFns } from "./examinationReport.vue?vue&type=template&id=1ef56424&scoped=true"
import script from "./examinationReport.vue?vue&type=script&lang=js"
export * from "./examinationReport.vue?vue&type=script&lang=js"
import style0 from "./examinationReport.vue?vue&type=style&index=0&id=1ef56424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef56424",
  null
  
)

export default component.exports